import { getApiKey } from "../../../utils/apiKey";
import React from "react";
import { apiCall_domainV2 } from "../../api";
import { Link } from "react-router-dom";
import CountDown from "./CountDown";
import Spinner from "../../Spinner/Spinner";
import WheelofFortune from "../WheelOfFortune/WheelofFortune";
import axios from "axios";
import Header from "../../header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

class ClubKachar extends React.Component {
  state = {
    changeDetail: true,
    wheel: false,
    mainContent: true,
    data: [],
    loading: true,
    userInfo: null,
  };

  handleWheelDisplay = () => {
    this.setState({
      mainContent: !this.state.mainContent,
      wheel: !this.state.wheel,
    });
  };

  // api data
  componentDidMount() {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/market`, {
        headers,
      })
      .then((res) => {
        this.setState({ data: res.data, loading: false });
      });
    this.setState({
      userInfo: JSON.parse(localStorage.getItem("splash")).customer_info,
    });
  }

  render() {
    return this.state.loading ? (
      <Spinner />
    ) : (
      <>
        {!this.state.wheel ? (
          <Header
            showSearchBar={true}
            title="باشگاه مشتریان"
            changeDetail={true}
          />
        ) : null}
        {this.state.mainContent ? (
          <div className="customerClub">
            {/* {this.state.data.lotteries?.expire_time ? (
              <div className="customerClubHead">
                <img
                  src="/public/assets/img/CustomerClub/lottary.png"
                  alt="carousel"
                />

                <div className="content">
                  <div className="customerClubLotteryTitle">
                    <span>{this.state.data.lotteries.title}</span>
                    <span>روز شمار برگزاری قرعه کشی</span>
                  </div>
                  <div className="custumerClubLottery">
                    <CountDown
                      expire_time={this.state.data?.lotteries?.expire_time}
                    />
                    <i className="icon-time" />
                  </div>
                </div>
              </div>
            ) : null} */}
            <div className="customerClubBody">
              <div className="customerClubProfile">
                <span> {this.state.userInfo.name}</span>
                <div className="profileDetail">
                  <Link to={`/customerclub/scores`}>
                    <div className="profileUserPoints">
                      <span> امتیاز شما</span>
                      <span>{this.state.data.points.current}</span>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="clubSections">
                <Link to="/customerclub/bazarche">
                  <div className="clubs">
                    <span> بازارچه</span>
                    <span>مشاهده بازارچه</span>
                  </div>
                </Link>
                <Link to="/">
                  <div className="clubs">
                    <span> کمک به خیریه</span>
                    <span>همیار میشوم</span>
                  </div>
                </Link>
              </div>
              <div className="lotteryParticipation">
                <div className="participationImage">
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={4}
                    centeredSlides={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                  >
                    {this.state.data.sliders.map((slide) => (
                      <SwiperSlide>
                        <div className="SwiperIntro">
                          {slide.type === 0 ? (
                            <img src={slide.pic} alt="SwiperIntro"></img>
                          ) : slide.type === 3 ? (
                            <a href={slide.web_url}>
                              <img src={slide.pic} alt="SwiperIntro"></img>
                            </a>
                          ) : (
                            <Link
                              to={
                                slide.type === 2
                                  ? `/product/${slide.item_slug}`
                                  : `/categories/${slide.cat_id}`
                              }
                              passHref
                            >
                              <img src={slide.pic} alt="SwiperIntro"></img>
                            </Link>
                          )}
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
              <div className="lotterySection">
                <div onClick={() => this.handleWheelDisplay()}>
                  <div>
                    <h3>چرخونک</h3>
                    <span>شانستو امتحان کن</span>
                  </div>
                  <i className="icon-chevron-left" />
                </div>
                <div>
                  <Link to={"/customerclub/history"}>
                    <div>
                      <h3>تاریخچه</h3>
                      <span> تاریخچه باشگاه مشتریان</span>
                    </div>
                    <i className="icon-chevron-left" />
                  </Link>
                </div>
                {/* <div>
                  <Link to="/customerclub/faq">
                    <div>
                      <h3> سوالات متدوال</h3>
                      <span>مشاهده</span>
                    </div>
                    <i className="icon-chevron-left" />
                  </Link>
                </div> */}
                <div>
                  <Link to="/customerclub">
                    <div>
                      <h3> درباره باشگاه مشتریان</h3>
                      <span>مشاهده</span>
                    </div>
                    <i className="icon-chevron-left" />
                  </Link>
                </div>
              </div>
              <div className="checkChanceSection">
                <div className="checkChanceTitle">
                  <h3>شانستو بیشتر کن</h3>
                </div>
                <div className="checkChance">
                  <Link to="/mainPage">
                    <div className="checkChanceText">
                      <span>خرید از فروشگاه</span>
                      <span>
                        شما میتوانید با خرید از فروشگاه کاچار امتیاز کسب کنید
                      </span>
                    </div>
                    <div>
                      <i className="icon-chevron-left" />
                    </div>
                  </Link>
                </div>
                <div className="checkChance">
                  <Link to="/showMore/Refferal">
                    <div className="checkChanceText">
                      <span>دعوت از دوستان</span>
                      <span>
                        کد معرف خود را با دوستان خود به اشتراک بگذارید و امتیاز
                        کسب کنید
                      </span>
                    </div>
                    <div>
                      <i className="icon-chevron-left" />
                    </div>
                  </Link>
                </div>
                <div className="checkChance">
                  <Link to="/profile/CommentDashboard">
                    <div className="checkChanceText">
                      <span>ثبت دیدگاه خود</span>
                      <span>
                        با افزودن دیدگاه خود به محصولات میتوانید امتیاز بیشتری
                        کسب کنید
                      </span>
                    </div>
                    <div>
                      <i className="icon-chevron-left" />
                    </div>
                  </Link>
                </div>
                <div className="checkChance">
                  <Link to="/">
                    <div className="checkChanceText">
                      <span>به روز رسانی اطلاعات خودرو</span>
                      <span>
                        با افزودن آخرین وضعیت خودرو خود امتیاز کسب کنید
                      </span>
                    </div>
                    <div>
                      <i className="icon-chevron-left" />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.wheel && (
          <>
            <WheelofFortune
              handleWheelDisplay={this.handleWheelDisplay}
              currentPoints={this.state.data?.points?.current}
              requiredPoints={this.state.data.wheelchairs_points}
            />
          </>
        )}
      </>
    );
  }
}
export default ClubKachar;
